import { Schema as S } from "effect";

export const FindCalendarRequestSchema = S.Struct({
  _id: S.String,
});

export type FindCalendarRequest = S.Schema.Type<typeof FindCalendarRequestSchema>;
